import {Checkbox, Flex, message, Typography} from 'antd'
import TextArea from "antd/es/input/TextArea";
import {TrackerBean} from "common/api/api.ts";
import {trackerApi} from 'common/api/entitiesApi.tsx';
import {env} from "common/env";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const {Text} = Typography

const TrackerCode = ({tracker, onTrackerChange}: { tracker: TrackerBean, onTrackerChange: (tracker: TrackerBean) => void }) => {

    const [price1, setPrice1] = useState<boolean>(!!tracker.specifyPriceInJsTag)
    const [price2, setPrice2] = useState<boolean>(!!tracker.specifyPriceInPrebidJs)
    const [saving, setSaving] = useState<boolean>(false)

    useEffect(() => {
        setPrice1(!!tracker.specifyPriceInJsTag)
        setPrice2(!!tracker.specifyPriceInPrebidJs)
    }, [tracker])

    function getHTML() {
        return `<script async src="${env.asteriotrackUrl}?agency=${tracker.agencyId}&adv=${tracker.advertiserId}&token=${tracker.token}"></script>` +
            `\n<script>window.asteriotrack = window.asteriotrack || []; window.asteriotrack.push({event: 'postback'${pricePrp(price1)}});</script>`
    }

    function getURL() {
        return `${env.asteriotrackEndpoint}/event/tracker/${tracker.advertiserId}?token=${tracker.token}&trackingId=[TRACKING_ID]${priceParam(price2)}`
    }

    function priceParam(priceFlag) {
        return priceFlag ? `&price=[PRICE]` : ''
    }

    function pricePrp(priceFlag) {
        return priceFlag ? `, price: '[PRICE]'` : ''
    }


    function copy(code) {
        navigator.clipboard.writeText(code)
        message.success("Copied", 0.65)
        return false
    }

    function updateTrackerPriceFlag(field: 'specifyPriceInJsTag' | 'specifyPriceInPrebidJs', value: boolean) {
        const previousPrice1 = price1
        const previousPrice2 = price2
        const updatedTracker = {...tracker, [field]: value}
        const priceFlags = {
            specifyPriceInJsTag: !!updatedTracker.specifyPriceInJsTag,
            specifyPriceInPrebidJs: !!updatedTracker.specifyPriceInPrebidJs
        }

        if (field === 'specifyPriceInJsTag') {
            setPrice1(value)
        } else {
            setPrice2(value)
        }

        setSaving(true)
        trackerApi.updateTrackerPriceFlags(priceFlags, tracker.id as number)
            .then(response => {
                if (response.data) {
                    onTrackerChange(response.data)
                }
            })
            .catch(error => {
                setPrice1(previousPrice1)
                setPrice2(previousPrice2)
                message.error(error?.message || 'Failed to save tracker')
            })
            .finally(() => setSaving(false))
    }

    return <>
        <Flex justify="space-between">
            <Text style={{fontSize: 16}}>Inject this HTML to track events on the page:</Text>
            <Text><Link to='#' onClick={() => copy(getHTML())}>Copy</Link></Text>
        </Flex>
        <TextArea readOnly style={{resize: "none"}} value={getHTML()} rows={4}></TextArea>
        <Checkbox disabled={saving} checked={price1} onChange={e => updateTrackerPriceFlag('specifyPriceInJsTag', e.target.checked)}/> <Text style={{fontSize: 12}}>specify
        price in [PRICE] placeholder</Text>

        <br/><br/>

        <Flex justify="space-between">
            <Text style={{fontSize: 16}}>Or use this URL to register event via server-side call:</Text>
            <Text><Link to='#' onClick={() => copy(getURL())}>Copy</Link></Text>
        </Flex>
        <TextArea readOnly style={{resize: "none"}} value={getURL()} rows={4}></TextArea>
        <Text style={{fontSize: 12}}>The [TRACKING_ID] is Asterio DSP event id which is usually transferred via the
            landing page parameter</Text>
        <br/>
        <Checkbox disabled={saving} checked={price2} onChange={e => updateTrackerPriceFlag('specifyPriceInPrebidJs', e.target.checked)}/> <Text style={{fontSize: 12}}>specify
        price in [PRICE] placeholder</Text>
    </>
}

export default TrackerCode
